import { ISelectComPesquisaProps, SelectComPesquisa } from "@/Components/SelectComPesquisa";
import { useListarInscricoesPorResponsavel } from "@/Services/Domain/Viagem/InscricaoService";

export interface IInscricaoResponsavelSelectProps extends ISelectComPesquisaProps {
    codResponsavel?:number;
    codCentroDeCusto?:number[]|null;
}
export default function InscricaoResponsavelSelect({
    codResponsavel,
    codCentroDeCusto,
    disabled,
    ...rest
}:IInscricaoResponsavelSelectProps) {
    const {
        data,
        isLoading,
        isSuccess,
        isError
    } = useListarInscricoesPorResponsavel({
        codResponsavel : codResponsavel ?? 0,
        codCentroDeCusto : codCentroDeCusto,
        enabled : !(codResponsavel === undefined || codResponsavel === null || isNaN(codResponsavel) || Number.parseInt(codResponsavel as any) <= 0)
    });

    return <SelectComPesquisa 
        {...rest}
        loading={isLoading}
        disabled={(isSuccess === false || isError) ? true : disabled}
        allowClear={true}
        placeholder={"Selecione um responsável"}
        options={data?.map(m => {
            return {
                value : m.codigo,
                label : `${m.aluno?.pessoa?.nome} - ${m.viagem?.titulo} ${m.viagem?.turma} (${m.viagem?.inicio instanceof Date ? m.viagem?.inicio?.toLocaleDateString() : m.viagem?.inicio?.toString()})`
            }
        })}
    />
}